import { ColumnDef } from '@tanstack/react-table';
import { Loader, Stack } from 'component-library';
import { useTranslation } from 'react-i18next';

import { SuspenseBoundary } from '@/components';

import { LandMonitoringPageWrapper } from '../../components/LandMonitoring.page-wrapper';
import { PlotRow } from '../../components/plot-list/Cells';
import { PlotListDesktop } from '../../components/plot-list/PlotListDesktop';
import { PlotListTitle } from '../../components/plot-list/PlotListTitle';
import { ToggleSortButton } from '../../components/plot-list/ToggleSortButton';
import { AreaCell } from '../plots/components/Cells';

export const DeforestationDetailPage = () => {
  const { t } = useTranslation();

  const plotListFilters = {
    is_deforested: true,
  };

  const customPlotListColumns: ColumnDef<PlotRow>[] = [
    {
      accessorKey: 'area',
      header: ({ column }) => (
        <ToggleSortButton column={column} className='-ml-2.5'>
          {t('shared.plots.tableHeader.plotSize')}
        </ToggleSortButton>
      ),
      cell: AreaCell,
    },
  ];

  return (
    <LandMonitoringPageWrapper title={t('shared.ncaDetail.details.deforestation.deforestation')}>
      <SuspenseBoundary
        fallback={
          <Stack center className='h-[600px]'>
            <Loader />
          </Stack>
        }
      >
        <PlotListTitle title={t('shared.ncaDetail.details.deforestation.plotsAffectedByDeforestation')} />
        <PlotListDesktop plotFilters={plotListFilters} customColumns={customPlotListColumns} />
      </SuspenseBoundary>
    </LandMonitoringPageWrapper>
  );
};
